/**
 * Default impression delay in milliseconds.
 */
export const DEFAULT_IMPRESSION_DELAY = 1000;
/**
 * Default name of a Feature App if none provided.
 */
export const FEATURE_APP_NAME_UNKNOWN = 'unknown';
